import '../scss/main.scss';
import $ from 'jquery';
// import { createApp } from 'vue';
// import { createPinia } from 'pinia';
// import { useRouter } from './route';
// import App from '../vue/App.vue';

// Vue.js
// createApp(App).use(createPinia()).use(useRouter).mount('#app');

// jQuery
$(function () {
  $('.js-hamburger').on('click', function () {
    $('.js-drawer-navi').fadeToggle();
    $('.js-header').toggleClass('__opened-drawer');
    $(this).toggleClass('__close');
  });
  $(window).on('resize', function () {
    if (window.matchMedia('(min-width: 1025px)').matches) {
      $('.js-drawer-navi').fadeOut();
      $('.js-header').removeClass('__opened-drawer');
      $('.js-hamburger').removeClass('__close');
    }
  });
  $('.js-drawer-navi-links a').on('click', function () {
    $('.js-drawer-navi').fadeOut();
    $('.js-header').removeClass('__opened-drawer');
    $('.js-hamburger').removeClass('__close');
  });
});

const scrollTop = document.querySelector('.js-scroll-top');
scrollTop?.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
});
